import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { ControlService } from '../../../services/control/control.service';
import { createPlainColumn } from '../../../shared/components/kite-grid/column-utils/column-utils';

@Component({
    selector: 'app-control',
    templateUrl: './control.component.html',
    styleUrls: ['./control.component.scss'],
    standalone: false
})
export class ControlComponent implements OnInit {

  selectForm: UntypedFormGroup;
  gridData: any[] = [];
  columnDefs: any[] = [];

  dataTable: any[] = [];
  cargando: boolean = false;
  select_arr = [
    'clients',
    'agreements',
    'orders',
    'projects',
    'prospects',
    'surveys',
    'tanks',

  ];

  constructor(private fb: UntypedFormBuilder,
            private controlService:ControlService) { }

  ngOnInit(): void {

    this.selectForm = this.fb.group({
      selectdb: [''],

    });

  }


  async selectCollection(){
    this.gridData = [];
    this.columnDefs = [];

    const _collection = this.selectForm.get('selectdb').value;
    this.dataTable = [];

    switch (_collection) {
      case 'clients':

        this.cargando = true;
        this.dataTable = await this.controlService.getAllAsyncByCollection(_collection).then(({clients})=>clients).catch(err => console.log(err));

        let dataClients = [];

        this.dataTable.forEach((element, index)=>{
          dataClients.push({
            id: index + 1,
            contact_name: element.contact_name,
            email: element.email,
            address: element.address,
            ident_GUI: element.ident_GUI
        });
        });
       const columnsClientes = [
          { binding: 'id', header: 'id', width: '*' },
          { binding: 'contact_name', header: 'contact_name', width: '*', format: 'n2' },
          { binding: 'email', header: 'email', width: '*', format: 'n2' },
          { binding: 'address', header: 'address', width: '*', format: 'n2' },
          { binding: 'ident_GUI', header: 'ident_GUI', width: '*', format: 'n2' },

        ]
        this.createTable(dataClients, columnsClientes);
        this.cargando = false;

        break;
      case 'agreements':

        this.cargando = true;
        this.dataTable = await this.controlService.getAllAsyncByCollection(_collection).then(({agreements})=>agreements);
        let dataAgreements = [];

        this.dataTable.forEach((element, index)=>{
          dataAgreements.push({
            name_agreement: element.name_agreement,
            sales_person: element.sales_person,
            created_at: element.created_at.split('T')[0],
            active: element.active,

        });
        });
        const columnsAgreements = [
          { binding: 'name_agreement', header: 'name_agreement', width: '*', format: 'n2' },
          { binding: 'sales_person', header: 'sales_person', width: '*', format: 'n2' },
          { binding: 'created_at', header: 'created_at', width: '*', format: 'n2' },
          { binding: 'active', header: 'Estado', width: '*', format: 'n2' },

        ];
        this.createTable(dataAgreements, columnsAgreements);
        this.cargando = false;

        break;
      case 'orders':
        this.cargando = true;
        this.dataTable = await this.controlService.getAllAsyncByCollection(_collection).then(({orders})=> orders);
        this.cargando = false;

        break;
      case 'projects':
        this.cargando = true;
        this.dataTable = await this.controlService.getAllAsyncByCollection(_collection).then(({projects})=> projects);
        let dataProjects = [];

        this.dataTable.forEach((element, index)=>{
          dataProjects.push({
            contact_name: element.contact_name,
            name_client_address: element.name_client_address,
            container_size: element.container_size,
            created_at: element.created_at.split('T')[0],
            gallons: element.gallons,
            price: element.price,
            active: element.active,


        });
        });
        const columnsProjects= [
          { binding: 'contact_name', header: 'contact_name', width: '*', format: 'n2' },
          { binding: 'name_client_address', header: 'name_client_address', width: '*', format: 'n2' },
          { binding: 'container_size', header: 'container_size', width: '*', format: 'n2' },
          { binding: 'created_at', header: 'created_at', width: '*', format: 'n2' },
          { binding: 'gallons', header: 'gallons', width: '*', format: 'n2' },
          { binding: 'price', header: 'price', width: '*', format: 'n2' },
          { binding: 'active', header: 'Estado', width: '*', format: 'n2' },

        ];
        this.createTable(dataProjects, columnsProjects);
        this.cargando = false;
        break;

        case 'prospects':
        this.cargando = true;
        this.dataTable = await this.controlService.getAllAsyncByCollection(_collection).then(({prospects})=> prospects);
        let dataProspects = [];

        this.dataTable.forEach((element, index)=>{
          dataProspects.push({
            name_prospect: element.name_prospect,
            survey_status: element.survey_status,
            created_at: element.created_at.split('T')[0],
            active: element.active,

        });
        });
        const columnsProspects= [
          { binding: 'name_prospect', header: 'name_prospect', width: '*', format: 'n2' },
          { binding: 'survey_status', header: 'survey_status', width: '*', format: 'n2' },
          { binding: 'created_at', header: 'created_at', width: '*', format: 'n2' },
          { binding: 'active', header: 'Estado', width: '*', format: 'n2' },

        ];
        this.createTable(dataProspects, columnsProspects);
        this.cargando = false;
        break;
      case 'surveys':

        this.cargando = true;
        this.dataTable = await this.controlService.getAllAsyncByCollection(_collection).then(({surveys})=> surveys);
        let dataSurveys = [];

        this.dataTable.forEach((element, index)=>{
          dataSurveys.push({
            name_client_address: element.name_client_address,
            address: element.address,
            created_at: element.created_at.split('T')[0],
            status: element.status,
            active: element.active,

        });
        });
        const columnsSurveys= [
          { binding: 'name_client_address', header: 'name_client_address', width: '*', format: 'n2' },
          { binding: 'address', header: 'address', width: '*', format: 'n2' },
          { binding: 'created_at', header: 'created_at', width: '*', format: 'n2' },
          { binding: 'status', header: 'status', width: '*', format: 'n2' },
          { binding: 'active', header: 'Estado', width: '*', format: 'n2' },

        ];
        this.createTable(dataSurveys, columnsSurveys);
        this.cargando = false;

        break;
      case 'tanks':

        this.cargando = true;
        this.dataTable = await this.controlService.getAllAsyncByCollection(_collection).then(({tanks})=> tanks);
        let dataTanks = [];

        this.dataTable.forEach((element, index)=>{
          dataTanks.push({
            name_client_address: element.name_client_address,
            address: element.address,
            created_at: element.created_at.split('T')[0],
            ident_order: element.ident_order,
            status: element.status,
            active: element.active,

        });
        });
        const columnsTanks= [
          { binding: 'name_client_address', header: 'name_client_address', width: '*', format: 'n2' },
          { binding: 'address', header: 'address', width: '*', format: 'n2' },
          { binding: 'created_at', header: 'created_at', width: '*', format: 'n2' },
          { binding: 'ident_order', header: 'ident_order', width: '*', format: 'n2' },
          { binding: 'status', header: 'status', width: '*', format: 'n2' },
          { binding: 'active', header: 'Estado', width: '*', format: 'n2' }

        ];
        this.createTable(dataTanks, columnsTanks);
        this.cargando = false;
        break;
      default:
        break;
    }
}
createTable(data, columnas){
    this.gridData = data;
    this.columnDefs = columnas.map((c: any) =>
      createPlainColumn({ field: c.binding, headerName: c.header, flex: 1, cellClass: 'ag-cell-left' })
    );
}
}
